export type AdminFeatureKey =
  | "dashboard"
  | "members"
  | "leads"
  | "subscriptions_orders"
  | "exercises"
  | "wod"
  | "transformation_wod"
  | "dietplans"
  | "programs"
  | "content"
  | "content_management";

export const ADMIN_FEATURE_KEYS: AdminFeatureKey[] = [
  "dashboard",
  "members",
  "leads",
  "subscriptions_orders",
  "exercises",
  "wod",
  "transformation_wod",
  "dietplans",
  "programs",
  "content",
  "content_management",
];

export const ADMIN_FEATURE_PATHS: Record<AdminFeatureKey, string> = {
  dashboard: "/",
  members: "/members",
  leads: "/leads",
  subscriptions_orders: "/subscriptions-orders",
  exercises: "/exercise",
  wod: "/wod",
  transformation_wod: "/transformation-wod",
  dietplans: "/dietplans",
  programs: "/programs",
  content: "/content",
  content_management: "/content-management",
};

const parseEnabledFeatures = (): Set<AdminFeatureKey> => {
  const raw = process.env.REACT_APP_ADMIN_ENABLED_FEATURES;

  if (!raw || !raw.trim()) {
    return new Set(ADMIN_FEATURE_KEYS);
  }

  const tokens = raw
    .split(",")
    .map((token) => token.trim().toLowerCase())
    .filter(Boolean);

  if (tokens.includes("all") || tokens.includes("*")) {
    return new Set(ADMIN_FEATURE_KEYS);
  }

  const enabled = new Set<AdminFeatureKey>();

  tokens.forEach((token) => {
    if ((ADMIN_FEATURE_KEYS as string[]).includes(token)) {
      enabled.add(token as AdminFeatureKey);
    }
  });

  if (enabled.size === 0) {
    // Avoid accidental lockout when env is misconfigured.
    return new Set(ADMIN_FEATURE_KEYS);
  }

  return enabled;
};

const ENABLED_ADMIN_FEATURES = parseEnabledFeatures();

export const isAdminFeatureEnabled = (featureKey: AdminFeatureKey): boolean =>
  ENABLED_ADMIN_FEATURES.has(featureKey);

export const getFirstEnabledAdminPath = (): string | null => {
  const firstEnabled = ADMIN_FEATURE_KEYS.find((key) =>
    isAdminFeatureEnabled(key)
  );

  return firstEnabled ? ADMIN_FEATURE_PATHS[firstEnabled] : null;
};
